<template>
  <div>
    <Header />
    <Downtime-Banner />
    <div class="body">
      <div v-if="!loading" class="filter-section">
        <!-- CRM FOR BULK PENDING -->
        <!-- <Crm-Export
          v-on:crmUpgradePopup="showUpgradePopup"
          :pageType="'Bulk'"
        />-->
        <div
          class="check-list-section"
          :class="{ 'flex-end': !isContactCheckBtn }"
        >
          <div class="sel-all-section" v-if="isContactCheckBtn">
            <input
              type="checkbox"
              id="selectAll"
              name="selectAll"
              v-model="selectContacts"
              v-on:change="checkContactSelected"
            />
            <span class="checkmark"></span>
          </div>
          <div class="list-section">
            <Create-List
              :contactId="[]"
              :listType="'bulk'"
              :showActivationPopup="showActivationError"
            />
          </div>
        </div>
      </div>
      <div v-else class="list-loader">
        <!-- CRM FOR BULK LOADER -->
        <!-- <Crm-Export-Loader v-if="false"/> -->
        <div class="list-loader-section">
          <div class="linear-background loader-check-box"></div>
          <Create-List-Floating-Label />
        </div>
      </div>
      <div v-if="false">
        <Review-Popup
          v-if="showReviewPopup"
          v-on:reviewPopupClosed="showReviewPopup = false"
        />
      </div>
      <Upgrade-Popup
        v-if="showPopup"
        :upgradePopupType="upgradePopupType"
        v-on:clickedOutside="showPopup = false"
      />
      <Activation-Popup
        v-if="showActivationPopup"
        v-on:closed="showActivationPopup = false"
      />
      <Credit-Limit-Popup
        v-if="showCreditLimitPopup"
        v-on:clickedOutside="showCreditLimitPopup = false"
      />
      <ul class="bulk__contact__List">
        <li v-for="(ele, index) in profileList" :key="index">
          <div
            v-if="!loading"
            :class="{ 'sel-chk-box': isContactCheckBtn === true }"
          >
            <input
              type="checkbox"
              :id="getContactData(ele).mcId"
              :name="getContactData(ele).linkedinId"
              :value="getContactData(ele).mcId"
              v-on:change="getLinkedInMapContact(getContactData(ele))"
              v-model="getCheckedContacts"
              v-if="canShowCheckBox(ele)"
            />
            <span class="checkmark"></span>
          </div>
          <div
            v-else
            class="linear-background loader-check-box chk-box-space"
          ></div>
          <div class="contact-card-section">
            <Contact-Card
              :enableReviewPopup="enableReviewPopup"
              :showUpgradePopup="showUpgradePopup"
              :loading="loading"
              :profileData="getContactData(ele)"
              :requestId="requestId"
            />
          </div>
        </li>
        <li
          v-if="isContactCheckBtn && profileList && profileList.length >= 1"
          class="blur-li"
        >
          <V-Button
            :className="'bulk-get-email-but'"
            :callback="findAllEmail"
            :text="getContactText"
            :loading="bulkLoader"
          />
        </li>
      </ul>
    </div>
    <Help-Section></Help-Section>
    <Linkedin-Connect-Popup
      v-if="showLinkedInConnect"
      v-on:success="
        showLinkedInConnect = false
        findAllEmail()
      "
      v-on:failed="
        showLinkedInConnect = false
        showUpgradePopup('li_connect_multi')
      "
      v-on:close="showLinkedInConnect = false"
      v-on:skip="
        showLinkedInConnect = false
        showUpgradePopup('li_connect_skip')
      "
    />
  </div>
</template>

<script>
import ContactCard from '@/components/ContactCard.vue'
import CreditLimitPopup from '@/components/CreditLimitPopup.vue'
import ReviewPopup from '@/components/ReviewPopup.vue'
import Header from '@/components/Header.vue'
import DowntimeBanner from '@/components/DowntimeBanner.vue'
import { post } from './../assets/util/rest.js'
import sharedFunctions from '@/assets/util/functions.js'
import button from '@/components/Button'
import CreateList from '@/components/CreateList'
import UpgradePopup from '@/components/UpgradePopup.vue'
import sharedFunction from './../assets/util/functions.js'
import { MxEvent, HttpUrl } from './../assets/util/constants/analytics.js'
import CreateListFloatingLabel from '@/components/CreatelistFloatingLabel'
import LinkedinConnectVue from '@/components/LinkedinConnect.vue'
// import CrmExport from '@/components/crmExport/CrmExport'
// import CrmExportLoader from '@/components/crmExport/CrmExportLoader'
import helpSection from '@/components/help/Helpmenu.vue'
import ActivationPopup from '@/components/ActivationPopup.vue'

export default {
  name: 'LinkedinBulk',
  props: ['profileData'],
  watch: {
    profileData: {
      immediate: true,
      handler(newValue, oldValue) {
        const { profiles: newProfiles = null } = newValue || {}
        const { profiles: oldProfiles = null } = oldValue || {}
        if (newProfiles && oldProfiles != newProfiles) {
          this.profileList = newProfiles
          this.enrichProfileData(newProfiles)
          this.trackBulkProfileLoad(newValue)
        }
      },
    },
  },
  computed: {
    isContactCheckBtn: function () {
      let contactEmailExist = 0
      if (!this.$store.state.linkedin.bulk.contacts) return null
      Object.values(this.$store.state.linkedin.bulk.contacts).forEach((c) => {
        if (c.email) {
          contactEmailExist++
        }
      })
      return contactEmailExist > 0
    },
    totalContactExist: function () {
      let totalEmailExist = 0
      if (!this.$store.state.linkedin.bulk.contacts) return null
      Object.values(this.$store.state.linkedin.bulk.contacts).forEach((c) => {
        if (c.email) {
          totalEmailExist++
        }
      })
      return totalEmailExist
    },
    lbCreditsPlan() {
      return this.$store.state.header.lbCreditsPlan
    },
  },
  data: function () {
    return {
      profileList: [],
      loading: true,
      bulkLoader: false,
      showPopup: false,
      showCreditLimitPopup: false,
      upgradePopupType: null,
      showReviewPopup: false,
      getCheckedContacts: [],
      getLinkedInMap: {},
      getContactText: 'View All Contacts',
      selectContacts: false,
      requestId: null,
      showLinkedInConnect: false,
      showActivationPopup: false,
    }
  },
  created() {
    this.$store.state.linkedin.bulk.contacts = null
  },
  components: {
    'Contact-Card': ContactCard,
    Header: Header,
    'V-Button': button,
    'Review-Popup': ReviewPopup,
    'Upgrade-Popup': UpgradePopup,
    'Create-List': CreateList,
    'Create-List-Floating-Label': CreateListFloatingLabel,
    'Linkedin-Connect-Popup': LinkedinConnectVue,
    // 'Crm-Export': CrmExport,
    // 'Crm-Export-Loader': CrmExportLoader,
    'Help-Section': helpSection,
    'Activation-Popup': ActivationPopup,
    'Credit-Limit-Popup': CreditLimitPopup,
    'Downtime-Banner': DowntimeBanner,
  },
  methods: {
    closeListOutside() {
      this.$emit('closeListOutside', true)
    },
    getContactData(el) {
      if (el && el.linkedinId && this.$store.state.linkedin.bulk.contacts) {
        return this.$store.state.linkedin.bulk.contacts[el.linkedinId]
      }
      return el
    },
    canShowCheckBox(el) {
      return this.getContactData(el).email
    },
    enrichProfileData(profiles) {
      this.loading = true
      this.resetSelectContact()
      window.scrollTo(0, 0)
      let data = {}
      data['profiles'] = profiles
      data['currentUrl'] = ''
      post('li/adv/v2/profiles.htm', data)
        .then((response) => {
          this.loading = false
          if (response.status == 200) {
            this.requestId = response.headers.get('requestId')
            response
              .json()
              .then((res) => {
                for (let profile of profiles) {
                  if (profile.linkedinId && res[profile.linkedinId]) {
                    res[profile.linkedinId].companyUrl = profile.companyUrl
                    res[profile.linkedinId].isVerifiedDomain =
                      profile.isVerifiedDomain
                    res[profile.linkedinId].isSalesNavigator =
                      profile.isSalesNavigator
                    // Sales navigator string mismatch in variable name
                    this.$store.state.isSalesNavigator =
                      profile.isSalesNavigator
                    this.$store.state.user.phoneNumberEnabled =
                      res[profile.linkedinId].phoneNumberEnabled
                  }
                }
                this.$store.state.linkedin.bulk.contacts = res
              })
              .catch((e) => {
                this.loading = false
                console.log('err: ' + e)
              })
          } else {
            this.loading = false
            console.log('status: ' + response.status)
          }
        })
        .catch((e) => {
          this.loading = false
          console.log('error: ' + e)
        })
    },
    getDataForMixpanel() {
      let emailCount = 0
      this.$store.state.linkedin.bulk.unique_id = sharedFunction.generateUUID()
      Object.values(this.$store.state.linkedin.bulk.contacts).forEach((c) => {
        if (c.email) {
          emailCount++
        }
      })
      const dataMap = {
        totalContacts: this.profileList.length,
        maskedEmail: emailCount,
        uniqueId: this.$store.state.linkedin.bulk.unique_id,
        isSalesNavigator: this.$store.state.isSalesNavigator,
      }
      return dataMap
    },
    fireMixpanel(eventName, dataMap) {
      sharedFunction.track(eventName, dataMap, this.$store.state)
    },
    findAllEmail() {
      const dataMap = this.getDataForMixpanel()
      this.fireMixpanel(MxEvent.GET_ALL_CLICKED, dataMap)
      this.bulkLoader = true
      let contactIds = []
      let contactIdsMap = {}
      if (this.getCheckedContacts.length > 0) {
        contactIds = this.getCheckedContacts
        contactIdsMap = this.getLinkedInMap
      } else {
        for (let key in this.$store.state.linkedin.bulk.contacts) {
          if (
            this.$store.state.linkedin.bulk.contacts[key] &&
            this.$store.state.linkedin.bulk.contacts[key].mcId
          ) {
            contactIds.push(this.$store.state.linkedin.bulk.contacts[key].mcId)
            const liId =
              this.$store.state.linkedin.bulk.contacts[key].linkedinId
            contactIdsMap[this.$store.state.linkedin.bulk.contacts[key].mcId] =
              liId
          }
        }
      }
      const listName = this.$store.state.linkedin.list.selectedList
      const data = {
        contactIds,
        listName,
        sn: this.$store.state.isSalesNavigator,
      }
      post(HttpUrl.addContactToList, data)
        .then((response) => {
          this.resetSelectContact()
          this.bulkLoader = false
          switch (response.status) {
            case 200:
              response.json().then((res) => {
                let emailFound = res.emails.length
                let successMsg = `${
                  emailFound > 0 ? 'Successfully added ' + emailFound : 'No'
                } contact${
                  emailFound > 1 || emailFound === 0 ? 's' : ''
                } to the list ${listName}.`
                sharedFunction.showNotificationMsg(
                  successMsg,
                  2000,
                  '#4CAF50',
                  '#fff'
                )
                const contacts = res.emails
                if (this.lbCreditsPlan)
                  this.$store.state.header.credits = res.creditsLeft
                else this.$store.state.header.views = res.creditsLeft
                for (let contactInfo of contacts) {
                  const liId = contactIdsMap[contactInfo.mcId]
                  this.$store.state.linkedin.bulk.contacts[liId].email =
                    contactInfo.email
                  this.$store.state.linkedin.bulk.contacts[liId].phone =
                    contactInfo.phone
                  this.$store.state.linkedin.bulk.contacts[
                    liId
                  ].contactAlreadyOwned = true
                }
              })
              break
            case 419:
              // views exhausted
              this.showUpgradePopup('views')
              break
            case 423:
              // bulk views exhausted
              this.showUpgradePopup('bulk')
              break
            case 402:
              this.loading = false
              this.showUpgradePopup('daily_limit')
              break
            case 417:
              this.showLinkedInConnect = true
              break
            case 406:
              this.showUpgradePopup('li_connect_skip')
              break
            case 424:
              // show sales navigator
              this.showUpgradePopup('sales_navigator')
              break
            case 412:
              this.loading = false
              this.showActivationError()
              break
            case 420:
              this.setShowCreditLimitPopup()
              break
          }
        })
        .catch((e) => {
          console.log('error :' + e)
          this.bulkLoader = false
        })
    },
    showUpgradePopup(type) {
      if (type === 'credit_limit') {
        this.setShowCreditLimitPopup()
      } else {
        this.upgradePopupType = type
        this.showPopup = true
      }
    },
    setShowCreditLimitPopup() {
      this.showCreditLimitPopup = true
    },
    enableReviewPopup() {
      this.showReviewPopup = true
    },
    getLinkedInMapContact(data) {
      if (this.getCheckedContacts.indexOf(data.mcId) === -1) {
        delete this.getLinkedInMap[data.mcId]
      } else {
        this.getLinkedInMap[data.mcId] = data.linkedinId
      }
      this.contactCountNumber()
      if (this.totalContactExist === this.getCheckedContacts.length) {
        this.selectContacts = true
      } else {
        this.selectContacts = false
      }
    },
    checkContactSelected() {
      if (this.selectContacts) {
        Object.values(this.$store.state.linkedin.bulk.contacts).forEach((c) => {
          if (c && c.email) {
            if (this.getCheckedContacts.indexOf(c.mcId) === -1) {
              this.getCheckedContacts.push(c.mcId)
              this.getLinkedInMap[c.mcId] = c.linkedinId
            }
          }
        })
      } else {
        this.getCheckedContacts = []
        this.getLinkedInMap = {}
      }
      this.contactCountNumber()
    },
    contactCountNumber() {
      if (
        this.getCheckedContacts.length > 0 &&
        this.getCheckedContacts.length < 10
      ) {
        this.getContactText = `View Selected Contacts`
      } else {
        this.getContactText = 'View All Contacts'
      }
    },
    resetSelectContact() {
      this.getCheckedContacts = []
      this.getLinkedInMap = {}
      this.getContactText = 'View All Contacts'
      this.selectContacts = false
    },
    openCreateList() {
      this.showCreateList = true
    },
    clickOutsideDom() {
      //console.log($event)
    },
    trackBulkProfileLoad(profilesInfo) {
      const { profiles = [], isSalesNavigator = false } = profilesInfo || {}
      const linkedinUrls = profiles.map((item) =>
        item.linkedinId ? item.linkedinId : ''
      )
      sharedFunctions.track(
        isSalesNavigator
          ? MxEvent.bulkContactViewedSN
          : MxEvent.bulkContactViewed,
        {
          linkedinUrls,
        },
        this.$store.state
      )
    },
    showActivationError() {
      this.showActivationPopup = true
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.dis-none {
  display: none;
}
h3 {
  padding: 40px 0 0;
}
ul {
  margin: 0;
  list-style-type: none;
  padding: 0;
  li {
    display: flex;
    width: 100%;
  }
}
.contact-card-section {
  width: 100%;
}
.body {
  // border: 1px solid $primary-color;
  position: relative;
  // top: 51px;
  z-index: 0;
  .max-height {
    height: -webkit-fill-available;
  }
}

.bulk__contact__List {
  padding-top: 48px;
  li {
    box-shadow: 0px 2px 3px 0px #efefef;
    display: flex;
    align-items: flex-start;
    .sel-chk-box {
      padding: 12px 0px 15px 10px;
      width: 24px;
    }
  }
}

.blur-li {
  position: sticky;
  justify-content: center;
  bottom: 0px;
  background: rgba(255, 255, 255);
  -webkit-box-shadow: 0px -6px 10px 20px $white;
  box-shadow: 0px 0px 10px 20px $white;
  padding: 7px 0px 15px 0px;
  margin-top: 10px;
  button {
    padding: 14px;
    width: 80%;
    font-size: 14px;
  }
}
.blur-li::v-deep .bulk-get-email-but {
  padding: 8px 0px;
  font-size: 14px;
  width: 226px;
}
.sel-all-section {
  display: flex;
  padding: 10px;
}
.filter-section {
  position: fixed;
  width: 100%;
  height: 48px;
  box-shadow: 0px 2px 3px 0px #efefef;
  background: $white;
  z-index: 2;
  .flex-end {
    justify-content: flex-end !important;
  }
  .check-list-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0 7px;
    .list-section::v-deep {
      display: flex;
      align-items: center;
      .list-wrap-btn-section {
        padding-right: 10px;
        .add__list {
          margin-right: 0;
          border-radius: 35px;
          background: $white;
          label {
            font-size: 10px;
            top: -6px;
            background: $white;
            color: $grey-text;
          }
          input {
            padding: 5px 20px 5px 15px;
            font-size: 12px;
          }
        }
        .dropdown__list {
          right: 10px;
        }
        .sharp__pointer {
          left: unset;
          right: 25px;
        }
      }
      .list__data__section {
        li {
          padding: 5px;
        }
      }
      .create__list__btn {
        padding: 7px 5px;
      }
    }
  }
}

.list-loader::v-deep {
  width: 100%;
  z-index: 1;
  background: $white;
  position: fixed;
  display: flex;
  flex-direction: column;
  height: 48px;
  box-shadow: 0px 2px 3px 0px #efefef;
  .list-loader-section {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
  }
}
.loader-check-box {
  padding: 7px;
  border-radius: 3px;
}
.chk-box-space {
  margin: 15px 0px 15px 10px;
}
</style>
